let BACKEND_URL = null;

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    BACKEND_URL = "https://localhost:3232"; //change to local IP to test with phone on LAN
} else {
    BACKEND_URL = "https://api.echoagent.io";
}

const convertFirestoreTimeStampToDateObject = (tS) => {
    return new Date(tS._seconds * 1000)
}

export { BACKEND_URL, convertFirestoreTimeStampToDateObject }
